import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LocalStorageContextType {
  storage: Record<string, any>;
  updateStorage: (obj: Record<string, any>) => void;
}

const LocalStorageContext = createContext<LocalStorageContextType | null>(null);

interface LocalStorageProviderProps {
  children: ReactNode;
}

export const LocalStorageProvider: React.FC<LocalStorageProviderProps> = ({ children }) => {
  const [storage, setStorage] = useState<Record<string, any>>(() => {
    const savedData = localStorage.getItem('appData');
    return savedData ? JSON.parse(savedData) : {};
  });

  const updateStorage = (obj: Record<string, any>) => {
    setStorage(prev => {
      const newLocalStorage = { ...prev, ...obj };
      localStorage.setItem('appData', JSON.stringify(newLocalStorage));
      return newLocalStorage;
    });
  };

  return (
    <LocalStorageContext.Provider value={{ storage, updateStorage }}>
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorage = (): LocalStorageContextType => {
  const context = useContext(LocalStorageContext);
  if (!context) {
    throw new Error('useLocalStorage must be used within a LocalStorageProvider');
  }
  return context;
};
